angular.module('bizmetryApp').controller('RolesTabController', function (
    $scope, $rootScope, $mdDialog, $mdToast, $timeout, $sce, $q, RolesService, dialogService
) {
    console.log('🔒 Initializing Roles & Permissions Tab Controller');

    $scope.accountId = $scope.$parent.accountId;
    if (!$scope.accountId) {
        console.error('❌ Account ID not available in Roles Tab');
        return;
    }

    $scope.loading          = false;
    $scope.saving           = false; 
    $scope.rolesHierarchy   = [];
    $scope.displayHierarchy = [];
    $scope.allPermissions   = [];
    $scope.pendingNewRoles  = [];
    $scope.expandedNodes    = {};
    $scope.search           = { query: '' };   // object wrapper — survives ng-include child scopes
    $scope.searchMatchCount = -1;
    // Sort criterion sent to GET .../permissions-hierarchy?sortBy=... —
    // object wrapper for the same reason as `search` above: this template
    // is loaded via <ng-include> (user-management-dialog.html), which
    // always creates its own child scope. ng-model="sortOption" on a bare
    // primitive would write to a shadow property on THAT child scope
    // instead of this one — the <select> would visibly change, but
    // loadRolesHierarchy() (a closure over THIS $scope) would keep reading
    // the original, unchanged value forever. That's exactly what happened:
    // the API always got sortBy=PERMISSIONS_DESC regardless of the
    // dropdown. Also set before init() below fires the first load.
    $scope.sortState         = { value: 'PERMISSIONS_DESC' };
    $scope.confirmDeleteMap = {};              // roleId -> true (two-step delete confirm)
    $scope.confirmUnlinkMap = {};               // "parentId::childId" -> true (two-step unlink confirm)

    // "Add Permission" / "Add Child Role" dropdowns. These used to be
    // md-menu/$mdOpenMenu, but $mdMenu positions its popup relative to
    // document.body/the nearest md-dialog and miscalculates when the
    // trigger sits inside doubly-nested dialogs (User Management dialog ->
    // Roles tab) — the click registered (button shows pressed) but the
    // popup rendered with no visible size, so nothing appeared. A plain
    // ng-if dropdown replaced it, positioned via CSS `position: absolute`
    // relative to its own trigger — but that got clipped/invisible whenever
    // the trigger sat near the bottom of the scrollable `.rt-scrollable`
    // tree. Switching that to `position: fixed` (computed from
    // getBoundingClientRect()) *still* rendered wildly offset, growing
    // worse the further down the tree you scrolled: Angular Material's
    // dialog/tab wrappers (`.md-dialog-container`, the tabs content panel)
    // apply a CSS `transform`/`perspective` for their open/slide
    // animations, and per the CSS spec, ANY ancestor with a transform or
    // perspective becomes the containing block for `position: fixed`
    // descendants instead of the viewport — silently breaking the
    // getBoundingClientRect()-based math.
    //
    // The fix: escape that DOM subtree entirely. There is now exactly ONE
    // shared dropdown element for the whole tab (see the
    // `rtBodyPortal` directive below), physically appended to
    // <body> — a true top-level sibling of the dialog, unaffected by any
    // of its ancestors' transforms — and its content/position are driven
    // by `dropdownMode` + `dropdownTargetRole` rather than being
    // duplicated per role node (which also keeps the digest cheap: the
    // available-items list is computed once, only while a dropdown is
    // actually open, instead of once per role on every digest).
    $scope.openDropdownKey     = null;
    $scope.dropdownMode        = null;  // 'role-perm' | 'role-child' | 'pending-perm' | 'pending-child'
    $scope.dropdownTargetRole  = null;  // the role (or pendingRole) this dropdown is acting on
    $scope.dropdownPosition    = { left: 0, top: 0, openUpward: false };
    $scope.dropdownSearch      = { query: '' };

    var DROPDOWN_WIDTH      = 300;  // keep in sync with .rt-dropdown-menu width in roles-dialog.css
    var DROPDOWN_MAX_HEIGHT = 320;  // keep in sync with .rt-dropdown-menu max-height in roles-dialog.css
    var DROPDOWN_MARGIN     = 6;
    var VIEWPORT_PADDING    = 12;

    $scope.toggleDropdown = function (key, mode, target, $event) {
        if ($event) { $event.stopPropagation(); }

        if ($scope.openDropdownKey === key) {
            $scope.closeDropdown();
            return;
        }

        // 'role-perm'/'role-child' target an existing, persisted role —
        // 'pending-*' targets a not-yet-saved role, which can never be
        // super-user-locked. Direct-only check (not isRoleLockedForSuperUser):
        // adding to a role's OWN permission/child-role list is only blocked
        // when THIS role is directly on the super-user, not merely reachable
        // via a locked ancestor's cascade. Blocked here (not just at the
        // HTML button) as defense in depth against a stale dropdown key.
        if ((mode === 'role-perm' || mode === 'role-child') && $scope.isRoleDirectlyLockedForSuperUser(target)) {
            return;
        }

        $scope.dropdownMode       = mode;
        $scope.dropdownTargetRole = target;

        var triggerEl = $event && ($event.currentTarget || $event.target);
        if (triggerEl && triggerEl.getBoundingClientRect) {
            // md-button can report the click target as an inner <span>/md-icon —
            // walk up to the actual button element for a reliable rect.
            while (triggerEl && triggerEl.tagName !== 'BUTTON' && triggerEl.parentElement) {
                triggerEl = triggerEl.parentElement;
            }

            var rect = triggerEl.getBoundingClientRect();
            var spaceBelow = window.innerHeight - rect.bottom;
            var spaceAbove = rect.top;
            var openUpward = spaceBelow < DROPDOWN_MAX_HEIGHT && spaceAbove > spaceBelow;

            var left = Math.min(rect.left, window.innerWidth - DROPDOWN_WIDTH - VIEWPORT_PADDING);
            left = Math.max(left, VIEWPORT_PADDING);

            $scope.dropdownPosition = {
                left:       left,
                top:        openUpward ? null : rect.bottom + DROPDOWN_MARGIN,
                bottom:     openUpward ? (window.innerHeight - rect.top + DROPDOWN_MARGIN) : null,
                maxHeight:  openUpward ? Math.max(160, spaceAbove - DROPDOWN_MARGIN - VIEWPORT_PADDING)
                                       : Math.max(160, spaceBelow - DROPDOWN_MARGIN - VIEWPORT_PADDING),
                openUpward: openUpward
            };
        }

        $scope.dropdownSearch.query = '';
        $scope.dropdownAddedCount   = 0;
        $scope.openDropdownKey      = key;
    };

    $scope.isDropdownOpen = function (key) {
        return $scope.openDropdownKey === key;
    };

    $scope.closeDropdown = function () {
        $scope.openDropdownKey    = null;
        $scope.dropdownMode       = null;
        $scope.dropdownTargetRole = null;
        $scope.dropdownAddedCount = 0;
    };

    $scope.getDropdownStyle = function () {
        var pos = $scope.dropdownPosition || {};
        var style = {
            left:      pos.left + 'px',
            'max-height': Math.min(DROPDOWN_MAX_HEIGHT, pos.maxHeight || DROPDOWN_MAX_HEIGHT) + 'px'
        };
        if (pos.openUpward) {
            style.bottom = pos.bottom + 'px';
        } else {
            style.top = pos.top + 'px';
        }
        return style;
    };

    function _isChildRoleDropdown() {
        return $scope.dropdownMode === 'role-child' || $scope.dropdownMode === 'pending-child';
    }

    // Single source of truth for "what goes in the currently-open dropdown" —
    // delegates to the right existing getAvailable*() function based on
    // dropdownMode. Returns [] whenever nothing is open, so this stays cheap
    // even though it's re-evaluated on every digest (ng-repeat watches it).
    $scope.getDropdownItems = function () {
        if (!$scope.openDropdownKey || !$scope.dropdownTargetRole) return [];
        switch ($scope.dropdownMode) {
            case 'role-perm':     return $scope.getAvailablePermissions($scope.dropdownTargetRole);
            case 'role-child':    return $scope.getAvailableChildRoles($scope.dropdownTargetRole);
            case 'pending-perm':  return $scope.getAvailablePermissionsForPendingRole($scope.dropdownTargetRole);
            case 'pending-child': return $scope.getAvailableChildRolesForPendingRole($scope.dropdownTargetRole);
            default:              return [];
        }
    };

    // Selecting an item does NOT close the dropdown — it stays open so the
    // person can keep picking multiple permissions/roles in one go. The
    // clicked item disappears from the list on the next digest (it's now
    // "already added", so getAvailable*() filters it out) as the visual
    // confirmation; a running count is shown in the footer, and "Done" (or
    // clicking outside) closes it explicitly.
    $scope.dropdownAddedCount = 0;

    $scope.selectDropdownItem = function (item) {
        switch ($scope.dropdownMode) {
            case 'role-perm':     $scope.addPermissionToRole($scope.dropdownTargetRole, item);            break;
            case 'role-child':    $scope.addChildRoleToRole($scope.dropdownTargetRole, item);              break;
            case 'pending-perm':  $scope.addPermissionToPendingRole($scope.dropdownTargetRole, item);      break;
            case 'pending-child': $scope.addChildRoleToPendingRole($scope.dropdownTargetRole, item);       break;
        }
        $scope.dropdownAddedCount++;
    };

    $scope.getDropdownSearchPlaceholder = function () {
        return _isChildRoleDropdown() ? 'Search roles...' : 'Search permissions...';
    };

    $scope.getDropdownDoneLabel = function () {
        return $scope.dropdownAddedCount > 0
            ? 'Done (' + $scope.dropdownAddedCount + ' added)'
            : 'Done';
    };

    $scope.getDropdownEmptyMessage = function () {
        var isChild = _isChildRoleDropdown();
        var q = ($scope.dropdownSearch.query || '').trim();
        if (q) return 'No ' + (isChild ? 'roles' : 'permissions') + ' match "' + q + '"';
        return isChild ? 'No eligible roles to add' : 'All permissions already added';
    };

    // Predicate used with Angular's built-in `filter` filter on the
    // dropdown's ng-repeat, so typing in its search box narrows the list
    // by name, id, or description — independent of the main tree's search
    // bar above.
    $scope.matchesDropdownSearch = function (item) {
        var q = ($scope.dropdownSearch.query || '').trim().toLowerCase();
        if (!q) return true;
        if (!item) return false;
        return (item.name && item.name.toLowerCase().indexOf(q) !== -1) ||
               (item.id != null && String(item.id).toLowerCase().indexOf(q) !== -1) ||
               (item.description && item.description.toLowerCase().indexOf(q) !== -1);
    };

    // Scrolls to and briefly highlights a nested role's OWN top-level
    // entry in the tree — the shortcut offered next to the "Nested role —
    // read only" hint, since that's where the role can actually be
    // edited (see rt-role-header--root, set only on a role's root-level
    // rendering). A role that's only ever nested (no top-level entry of
    // its own) has nothing to jump to; that's surfaced via a toast rather
    // than silently doing nothing.
    $scope.navigateToRootRole = function (role, $event) {
        if ($event) { $event.stopPropagation(); }
        if (!role) return;

        var headerEl = null;
        var candidates = document.querySelectorAll('.rt-role-header--root');
        for (var i = 0; i < candidates.length; i++) {
            if (candidates[i].getAttribute('data-role-id') === String(role.id)) {
                headerEl = candidates[i];
                break;
            }
        }

        if (!headerEl) {
            $mdToast.showSimple('This role has no top-level entry of its own');
            return;
        }

        // Expand it too, so its Add Permission/Add Child Role controls are
        // right there — the whole point of jumping here is to edit it.
        $scope.expandedNodes[role.id] = true;

        headerEl.scrollIntoView({ behavior: 'smooth', block: 'center' });
        headerEl.classList.add('rt-role-header--jump-flash');
        $timeout(function () {
            headerEl.classList.remove('rt-role-header--jump-flash');
        }, 1200);

        $scope.hideNestedRoleTooltip();
    };

    // Hand-rolled tooltip for the go-to-root-entry arrow, instead of
    // Angular Material's own <md-tooltip>: md-tooltip positions itself the
    // same way $mdMenu does, which — as established above for the
    // dropdown — breaks inside this dialog's doubly-nested, transformed
    // DOM (it rendered garbled/mispositioned/clipped here). Same fix
    // pattern as the dropdown: one shared element, portaled to <body> via
    // rtBodyPortal, positioned in JS from the trigger's actual
    // getBoundingClientRect().
    $scope.tooltipVisible  = false;
    $scope.tooltipText     = '';
    $scope.tooltipPosition = { left: 0, top: 0 };

    var TOOLTIP_MAX_WIDTH = 260;
    var TOOLTIP_MARGIN    = 8;

    $scope.showNestedRoleTooltip = function (text, $event) {
        var triggerEl = $event && ($event.currentTarget || $event.target);
        if (!triggerEl || !triggerEl.getBoundingClientRect) return;

        while (triggerEl && triggerEl.tagName !== 'BUTTON' && triggerEl.parentElement) {
            triggerEl = triggerEl.parentElement;
        }

        var rect = triggerEl.getBoundingClientRect();
        var left = Math.min(rect.left, window.innerWidth - TOOLTIP_MAX_WIDTH - TOOLTIP_MARGIN);
        left = Math.max(left, TOOLTIP_MARGIN);

        $scope.tooltipText = text;
        // top is the trigger's TOP edge minus a margin; the tooltip itself
        // is shifted up by its own rendered height via CSS
        // `transform: translateY(-100%)`, so it always sits just above the
        // arrow regardless of how many lines the message wraps to.
        $scope.tooltipPosition = { left: left, top: rect.top - TOOLTIP_MARGIN };
        $scope.tooltipVisible  = true;
    };

    $scope.hideNestedRoleTooltip = function () {
        $scope.tooltipVisible = false;
    };

    $scope.getTooltipStyle = function () {
        var pos = $scope.tooltipPosition || {};
        return { left: pos.left + 'px', top: pos.top + 'px' };
    };

    var _searchDebounce  = null;
    var _deleteTimers    = {};
    var _unlinkTimers    = {};
    var _tempIdCounter   = 0;

    // pendingUnlinks: parentRoleId -> { childRoleId: true }. Tracks
    // parent→child edges the user has marked to unlink (nested "Delete"
    // click), as opposed to a full role deletion.
    var pendingUnlinks = {};

    // rolesById: id -> canonical role node object. A role that appears in
    // multiple places in the hierarchy (e.g. as a top-level entry AND as a
    // childRole of another role) is reduced to a SINGLE shared object
    // instance here, so an edit made from any occurrence is reflected
    // everywhere else that role is rendered.
    var rolesById = {};

    // ================================================================
    // INIT
    // ================================================================

    (function init() { loadRolesHierarchy(); })();

    // ================================================================
    // LOAD
    // ================================================================

    function loadRolesHierarchy() {
        $scope.loading = true;
        $scope.confirmDeleteMap = {};
        _editingFields = {}; // hoisted var (declared further down, in the
        // INLINE NAME/DESCRIPTION EDITING section) — reassignment here is
        // safe regardless of source order, so a role mid-edit before a
        // reload doesn't reopen its input against stale/replaced data.
        $scope.confirmUnlinkMap = {};
        pendingUnlinks = {};

        $q.all({
            hierarchy:   RolesService.getRolesHierarchy($scope.accountId, $scope.sortState.value),
            permissions: RolesService.getAllPermissions($scope.accountId)
        })
            .then(function (results) {
                rolesById = {};

                var rawHierarchy = results.hierarchy.data.roles || results.hierarchy.data || [];
                var canonical    = _canonicalizeTree(rawHierarchy);

                // Already sorted server-side (see ORDENAMIENTO below) —
                // canonicalization preserves array order.
                $scope.rolesHierarchy   = canonical;
                $scope.displayHierarchy = $scope.rolesHierarchy;
                $scope.allPermissions   = results.permissions.data || [];
                $scope.pendingNewRoles  = [];

                autoExpandFirstLevel();
            })
            .catch(function (err) {
                console.error('❌ Error loading roles & permissions:', err);
                $mdToast.showSimple('❌ Error loading roles & permissions');
            })
            .finally(function () { $scope.loading = false; });
    }

    // ── Canonicalization ─────────────────────────────────────────────
    function _canonicalizeTree(nodes) {
        return (nodes || []).map(function (node) {
            if (!node || !node.id) return node;

            if (rolesById[node.id]) {
                // Already materialized elsewhere in the tree — reuse the
                // exact same object instance instead of a duplicate.
                return rolesById[node.id];
            }

            var role = node;
            role.permissions           = role.permissions || [];
            role.description           = role.description || '';
            role.originalPermissionIds = role.permissions.map(function (p) { return p.id; });
            role.originalChildRoleIds  = (role.childRoles || []).map(function (c) { return c.id; });
            role.originalName          = role.name;
            role.originalDescription   = role.description;
            role.deleted               = false;

            rolesById[role.id] = role;
            role.childRoles = _canonicalizeTree(role.childRoles);
            return role;
        });
    }

    // ================================================================
    // SEARCH  (unchanged from the read-only explorer)
    // ================================================================

    $scope.onSearchChange = function () {
        if (_searchDebounce) $timeout.cancel(_searchDebounce);
        _searchDebounce = $timeout(function () {
            _applySearch($scope.search.query);
        }, 220);
    };

    $scope.clearSearch = function () {
        $scope.search.query     = '';
        $scope.searchMatchCount = -1;
        $scope.displayHierarchy = $scope.rolesHierarchy;
    };

    function _applySearch(query) {
        var q = (query || '').trim().toLowerCase();

        _recomputeDisplayHierarchy(q);

        if (!q) return;

        $timeout(function () {
            var el = document.querySelector('.role-node-header--match, .permission-node--match');
            if (el) el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 100);
    }

    function _recomputeDisplayHierarchy(q) {
        if (!q) {
            $scope.searchMatchCount = -1;
            $scope.displayHierarchy = $scope.rolesHierarchy;
            return;
        }

        var totalMatches = 0;

        $scope.displayHierarchy = _pruneTree($scope.rolesHierarchy, q, function (n) {
            totalMatches += n;
        });

        $scope.searchMatchCount = totalMatches;

        _expandAll($scope.displayHierarchy);
    }

    /*
     * The search view (`displayHierarchy`) is built by _pruneRole, which
     * clones matched roles/permissions (angular.extend({}, ...)) rather
     * than reusing the canonical objects directly. That's fine for
     * read-only browsing, but it means an edit made to the canonical
     * tree (via rolesById) while a search filter is active would NOT
     * automatically show up in the currently-rendered (cloned) nodes.
     * Every mutating action below calls this afterward so the filtered
     * view is always rebuilt fresh off the up-to-date canonical data —
     * changes stay reflected everywhere, search or no search. Unlike
     * _applySearch (used when the person types a query), this never
     * jumps the scroll position — it's a silent resync.
     */
    function _refreshDisplayIfSearching() {
        var q = ($scope.search.query || '').trim().toLowerCase();
        if (q) _recomputeDisplayHierarchy(q);
    }

    function _pruneTree(roles, q, addCount) {
        var result = [];
        (roles || []).forEach(function (role) {
            var pruned = _pruneRole(role, q, addCount);
            if (pruned) result.push(pruned);
        });
        return result;
    }

    function _pruneRole(role, q, addCount) {
        var selfMatch = _matches(role.name, q) || _matches(role.description, q);

        var processedPerms = (role.permissions || []).map(function (p) {
            var m = _matches(p.name, q) || _matches(p.description, q) || _matches(p.id, q);
            return angular.extend({}, p, { _isMatch: m });
        });
        var matchingPerms = processedPerms.filter(function (p) { return p._isMatch; });

        var prunedChildren = [];
        var prunedById = {};
        (role.childRoles || []).forEach(function (c) {
            var pr = _pruneRole(c, q, addCount);
            if (pr) {
                prunedChildren.push(pr);
                prunedById[pr.id] = pr;
            }
        });

        var hasDescendantMatch = matchingPerms.length > 0 || prunedChildren.length > 0;

        if (!selfMatch && !hasDescendantMatch) return null;

        if (selfMatch) addCount(1);
        addCount(matchingPerms.length);

        if (selfMatch) {
            var allChildren = (role.childRoles || []).map(function (c) {
                return prunedById[c.id] || angular.extend({}, c, { _isMatch: false });
            });

            return angular.extend({}, role, {
                _isMatch:    true,
                permissions: processedPerms,
                childRoles:  allChildren
            });
        }

        return angular.extend({}, role, {
            _isMatch:    false,
            permissions: matchingPerms,
            childRoles:  prunedChildren
        });
    }

    function _matches(text, q) {
        return !!text && text.toLowerCase().indexOf(q) !== -1;
    }

    $scope.highlight = function (text) {
        if (!text) return $sce.trustAsHtml('');
        var escaped = _esc(String(text));
        var q = ($scope.search.query || '').trim();
        if (!q) return $sce.trustAsHtml(escaped);
        var re = new RegExp('(' + _escRe(_esc(q)) + ')', 'gi');
        return $sce.trustAsHtml(escaped.replace(re, '<span class="search-highlight">$1</span>'));
    };

    function _esc(s) {
        return s.replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
    }

    function _escRe(s) {
        return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    }

    // ================================================================
    // ESTADÍSTICAS
    // ================================================================

    $scope.getTotalRolesCount = function () {
        return $scope.rolesHierarchy ? $scope.rolesHierarchy.length : 0;
    };

    $scope.getTotalPermissionsCount = function () {
        var unique = {};
        ($scope.rolesHierarchy || []).forEach(function (role) {
            (role.permissions || []).forEach(function (p) { unique[p.id] = true; });
        });
        return Object.keys(unique).length;
    };

    $scope.getPermissionsCountForRole  = function (role) { return _countPerms(role);      };
    $scope.getChildRolesCountForRole   = function (role) { return _countChildRoles(role);  };

    function _countPerms(role) {
        if (!role) return 0;
        var n = (role.permissions || []).length;
        (role.childRoles || []).forEach(function (c) { n += _countPerms(c); });
        return n;
    }

    function _countChildRoles(role) {
        if (!role || !(role.childRoles || []).length) return 0;
        var n = role.childRoles.length;
        role.childRoles.forEach(function (c) { n += _countChildRoles(c); });
        return n;
    }

    // ================================================================
    // EXPAND / COLLAPSE
    // ================================================================

    $scope.toggleNode    = function (id) { $scope.expandedNodes[id] = !$scope.expandedNodes[id]; };
    $scope.isNodeExpanded = function (id) { return $scope.expandedNodes[id] === true; };
    $scope.expandAll     = function ()   { _expandAll($scope.displayHierarchy); };
    $scope.collapseAll   = function ()   { $scope.expandedNodes = {}; };

    function _expandAll(roles) {
        (roles || []).forEach(function (r) {
            $scope.expandedNodes[r.id] = true;
            _expandAll(r.childRoles);
        });
    }

    function autoExpandFirstLevel() {
        ($scope.rolesHierarchy || []).forEach(function (r) {
            $scope.expandedNodes[r.id] = true;
        });
    }

    // ================================================================
    // ORDENAMIENTO
    // ================================================================
    // The tree arrives PRE-SORTED from the backend (GET .../permissions-
    // hierarchy?sortBy=...) — sortState.value (initialized up top, before
    // init() fires the first load) is just what we pass through as the
    // query param. The backend applies it recursively at every level (see
    // RolesService#sortHierarchy in account-microservice), so there's no
    // client-side sort step here at all.
    //
    // Changing the dropdown re-fetches from the server (loadRolesHierarchy),
    // same as what already happens after Save — which means, like Save,
    // it discards any unsaved in-memory edits. Acceptable tradeoff to avoid
    // duplicating the sort logic client-side; flagged here in case that
    // surprises someone later.

    $scope.onSortChange = function () {
        loadRolesHierarchy();
    };

    // ================================================================
    // ROLE DELETE (soft, in-memory — two-click confirm, undo-able)
    // ================================================================

    $scope.isRoleDeleted = function (role) {
        var canonical = rolesById[role.id];
        return !!(canonical && canonical.deleted);
    };

    $scope.isRoleDeletePending = function (role) {
        return !!$scope.confirmDeleteMap[role.id];
    };

    // referenced_by comes straight from the permissions-hierarchy API
    // response (RoleHierarchyNodeDTO.referencedBy) — the users/service
    // accounts that currently have this role assigned. Doesn't block
    // deletion outright — deleteRole() below routes an in-use role through
    // a warning dialog naming who has it, and only deletes if the person
    // explicitly proceeds. The backend then unassigns it from all of them
    // as part of the delete (see RolesService#deleteRole).
    $scope.isRoleInUse = function (role) {
        var canonical = rolesById[role.id] || role;
        return !!(canonical && canonical.referenced_by && canonical.referenced_by.length > 0);
    };

    $scope.getRoleReferencedByCount = function (role) {
        var canonical = rolesById[role.id] || role;
        return (canonical && canonical.referenced_by || []).length;
    };

    // A role assigned (directly, or via cascade from a parent — same
    // referenced_by the backend already computes) to the account's
    // super-user is a genuine hard block, unlike the general "in use"
    // case above: the backend refuses the delete outright (see
    // RolesService#deleteRole -> RoleProtectedException), so there's no
    // point offering a confirm-and-proceed path for it in the UI.
    $scope.isRoleLockedForSuperUser = function (role) {
        var canonical = rolesById[role.id] || role;
        var refs = (canonical && canonical.referenced_by) || [];
        return refs.some(function (r) {
            return r.type === 'USER' && r.isSuperUser === true;
        });
    };

    // Stricter than isRoleLockedForSuperUser above: true only when the role
    // is DIRECTLY on the super-user's userRoles, not merely reachable via a
    // locked ancestor's child-role cascade. A role locked only by cascade
    // still can't be deleted or unlinked from its locked parent (that part
    // stays governed by isRoleLockedForSuperUser), but its own name/
    // description/permissions/child-roles remain freely editable from its
    // own top-level entry — only the directly-assigned role is fully
    // immutable. Backend counterpart: RolesService#assertRoleDirectlyMutable.
    $scope.isRoleDirectlyLockedForSuperUser = function (role) {
        var canonical = rolesById[role.id] || role;
        var refs = (canonical && canonical.referenced_by) || [];
        return refs.some(function (r) {
            return r.type === 'USER' && r.isSuperUser === true && r.isDirect === true;
        });
    };

    $scope.getSuperUserLockTooltip = function (role) {
        if (role && $scope.isRoleDirectlyLockedForSuperUser(role)) {
            return "This role is assigned to the account's Super User, so it's immutable — " +
                "it can't be deleted, edited, or have permissions or child roles added or " +
                'removed, to guarantee access to the tenant.';
        }
        return 'A role assigned to the account\'s Super User depends on this one (directly ' +
            "or through one of its own child roles), so it can't be deleted or unlinked — " +
            'to guarantee access to the tenant. Its own name, description, permissions, and ' +
            'child roles can still be edited from here.';
    };

    // Shown on a child role's Unlink button when the PARENT (not the
    // child itself) is the one locked — the child role itself stays fully
    // editable (name/description/permissions/its own child roles) from its
    // own top-level entry; only this specific link can't be removed.
    $scope.getParentLockedTooltip = function () {
        return "The parent role is assigned to the account's Super User, so this link " +
            "can't be removed, to guarantee access to the tenant. The child role itself " +
            'is still editable from its own entry.';
    };

    // Single hover entry point for the delete button — picks whichever of
    // the two tooltips (hard super-user lock vs. general "in use") applies,
    // so the template doesn't need a nested ternary.
    $scope.onDeleteButtonHover = function (role, $event) {
        if ($scope.isRoleLockedForSuperUser(role)) {
            $scope.showNestedRoleTooltip($scope.getSuperUserLockTooltip(role), $event);
        } else if ($scope.isRoleInUse(role)) {
            $scope.showNestedRoleTooltip($scope.getRoleReferencedByTooltip(role), $event);
        }
    };

    // Only the first few names are listed — a role can be assigned to
    // dozens of users/service accounts, and the tooltip is a small
    // fixed-width box (see .rt-role-tooltip), not a scrollable list. The
    // count badge next to the delete button already shows the true total.
    var REFERENCED_BY_TOOLTIP_LIMIT = 5;

    $scope.getRoleReferencedByTooltip = function (role) {
        var canonical = rolesById[role.id] || role;
        var refs = (canonical && canonical.referenced_by) || [];
        if (!refs.length) return '';

        var shown = refs.slice(0, REFERENCED_BY_TOOLTIP_LIMIT).map(function (r) {
            return r.name + (r.type === 'SERVICE_ACCOUNT' ? ' (Service Account)' : ' (User)');
        });

        var remaining = refs.length - shown.length;
        var list = shown.join(', ') + (remaining > 0 ? ', +' + remaining + ' more' : '');

        return 'Assigned to: ' + list;
    };

    // Full (uncapped, unlike the hover tooltip above) HTML list for the
    // warning dialog below — there's room to scroll there, so no need to
    // truncate at REFERENCED_BY_TOOLTIP_LIMIT.
    function _buildRoleInUseWarningHtml(role) {
        var refs = role.referenced_by || [];

        var items = refs.map(function (r) {
            var typeLabel = r.type === 'SERVICE_ACCOUNT' ? 'Service Account' : 'User';
            return '<li style="margin-bottom:4px;">' +
                '<strong>' + _esc(r.name) + '</strong>' +
                ' <span style="color:#888;">(' + typeLabel + ')</span>' +
                '</li>';
        }).join('');

        return (
            '<p style="margin:0 0 12px 0;">' +
            'The role <strong>' + _esc(role.name) + '</strong> is currently assigned to ' +
            refs.length + ' user(s)/service account(s):' +
            '</p>' +
            '<ul style="margin:0 0 16px 0; padding-left:20px; max-height:200px; overflow-y:auto;">' +
            items +
            '</ul>' +
            '<p style="margin:0 0 14px 0; padding:12px 14px; background:#fff3e0; ' +
            'border-left:3px solid #ff9800; border-radius:4px; font-weight:600; color:#7a4a00;">' +
            'Deleting this role will immediately unassign it from everyone listed above. ' +
            'Depending on what other roles they hold, they may lose access to critical ' +
            'Bizmetry functionality — or lose the ability to access the platform entirely.' +
            '</p>' +
            '<p style="margin:0;">Are you sure you want to proceed?</p>'
        );
    }

    function _armRoleDeletion(canonical) {
        $timeout.cancel(_deleteTimers[canonical.id]);
        $scope.confirmDeleteMap[canonical.id] = false;
        canonical.deleted = true;
        _refreshDisplayIfSearching();
    }

    $scope.deleteRole = function (role, $event) {
        if ($event) $event.stopPropagation();
        var canonical = rolesById[role.id];
        if (!canonical || canonical.deleted) return;

        if ($scope.isRoleLockedForSuperUser(canonical)) {
            return; // hard block — the hover tooltip already explains why, nothing to confirm here
        }

        if ($scope.isRoleInUse(canonical)) {
            dialogService.showDecisionDialog(
                'Role In Use',
                _buildRoleInUseWarningHtml(canonical)
            ).then(function (decision) {
                if (decision === 'proceed') {
                    _armRoleDeletion(canonical);
                }
                // 'goBack' (or the dialog dismissed some other way) — do nothing.
            });
            return;
        }

        if (!$scope.confirmDeleteMap[role.id]) {
            $scope.confirmDeleteMap[role.id] = true;
            if (_deleteTimers[role.id]) $timeout.cancel(_deleteTimers[role.id]);
            _deleteTimers[role.id] = $timeout(function () {
                $scope.confirmDeleteMap[role.id] = false;
            }, 3000);
            return;
        }

        _armRoleDeletion(canonical);
    };

    $scope.restoreRole = function (role, $event) {
        if ($event) $event.stopPropagation();
        var canonical = rolesById[role.id];
        if (!canonical) return;
        canonical.deleted = false;
        _refreshDisplayIfSearching();
    };

    // ================================================================
    // CHILD ROLE UNLINK  (nested roles — removes the parent↔child edge
    // only, never the child role itself. Soft, in-memory, undo-able,
    // same two-click confirm pattern as ROLE DELETE above.)
    // ================================================================

    function _unlinkKey(parentId, childId) {
        return parentId + '::' + childId;
    }

    $scope.isUnlinkPending = function (parentRole, childRole) {
        return !!(parentRole && pendingUnlinks[parentRole.id] && pendingUnlinks[parentRole.id][childRole.id]);
    };

    $scope.isUnlinkPendingConfirm = function (parentRole, childRole) {
        return !!$scope.confirmUnlinkMap[_unlinkKey(parentRole.id, childRole.id)];
    };

    $scope.unlinkChildRole = function (parentRole, childRole, $event) {
        if ($event) $event.stopPropagation();
        // Unlinking edits the PARENT's own childRoles list, so it's the
        // parent's lock status that matters here — not the child's (a
        // locked role can still be safely unlinked from an unlocked
        // parent; its own permissions/assignment are untouched by that).
        if ($scope.isRoleLockedForSuperUser(parentRole)) return;
        var key = _unlinkKey(parentRole.id, childRole.id);

        if (!$scope.confirmUnlinkMap[key]) {
            $scope.confirmUnlinkMap[key] = true;
            if (_unlinkTimers[key]) $timeout.cancel(_unlinkTimers[key]);
            _unlinkTimers[key] = $timeout(function () {
                $scope.confirmUnlinkMap[key] = false;
            }, 3000);
            return;
        }

        $timeout.cancel(_unlinkTimers[key]);
        $scope.confirmUnlinkMap[key] = false;

        if (!pendingUnlinks[parentRole.id]) pendingUnlinks[parentRole.id] = {};
        pendingUnlinks[parentRole.id][childRole.id] = true;
        _refreshDisplayIfSearching();
    };

    $scope.restoreUnlink = function (parentRole, childRole, $event) {
        if ($event) $event.stopPropagation();
        if (pendingUnlinks[parentRole.id]) {
            delete pendingUnlinks[parentRole.id][childRole.id];
        }
        _refreshDisplayIfSearching();
    };

    function _hasPendingUnlinks() {
        return Object.keys(pendingUnlinks).some(function (pid) {
            return Object.keys(pendingUnlinks[pid] || {}).length > 0;
        });
    }

    function _countPendingUnlinks() {
        var count = 0;
        Object.keys(pendingUnlinks).forEach(function (pid) {
            count += Object.keys(pendingUnlinks[pid] || {}).length;
        });
        return count;
    }

    // ================================================================
    // PERMISSION ADD / REMOVE  (existing, persisted roles)
    // ================================================================

    $scope.getAvailablePermissions = function (role) {
        var canonical = rolesById[role.id] || role;
        var assignedIds = {};
        (canonical.permissions || []).forEach(function (p) { assignedIds[p.id] = true; });
        return ($scope.allPermissions || []).filter(function (p) { return !assignedIds[p.id]; });
    };

    $scope.addPermissionToRole = function (role, permission) {
        var canonical = rolesById[role.id];
        if (!canonical || canonical.deleted) return;
        if ($scope.isRoleDirectlyLockedForSuperUser(canonical)) return; // immutable
        if (canonical.permissions.some(function (p) { return p.id === permission.id; })) return;
        canonical.permissions = canonical.permissions.concat([permission]);
        _refreshDisplayIfSearching();
    };

    $scope.removePermissionFromRole = function (role, permission, $event) {
        if ($event) $event.stopPropagation();
        var canonical = rolesById[role.id];
        if (!canonical || canonical.deleted) return;
        if ($scope.isRoleDirectlyLockedForSuperUser(canonical)) return; // immutable
        canonical.permissions = canonical.permissions.filter(function (p) { return p.id !== permission.id; });
        _refreshDisplayIfSearching();
    };

    // ================================================================
    // CHILD ROLE ADD  (link an existing, already-persisted role as a
    // child of another. Symmetric to PERMISSION ADD above: mutates
    // canonical.childRoles immediately in memory, diffed against
    // originalChildRoleIds at save time. Removal stays a SEPARATE
    // mechanism — see CHILD ROLE UNLINK above — so this diff only ever
    // grows and never needs to compute removals itself.)
    // ================================================================

    /**
     * True if `toId` is reachable from `fromId` by walking childRoles —
     * i.e. `fromId` is already an ancestor of `toId`. Used to block
     * linking a role as a child of one of its own descendants, which
     * would otherwise create a cycle.
     */
    function _isReachable(fromId, toId) {
        if (fromId === toId) return true;
        var visited = {};
        function walk(id) {
            if (visited[id]) return false;
            visited[id] = true;
            var node = rolesById[id];
            if (!node) return false;
            return (node.childRoles || []).some(function (c) {
                return c.id === toId || walk(c.id);
            });
        }
        return walk(fromId);
    }

    /**
     * Roles that can legally be added as a child of `role`: existing,
     * persisted roles only (not the pending/unsaved "New Roles" list —
     * they don't have a real ID yet to link against), excluding the
     * role itself, roles already linked as its children, and any role
     * that is currently an ancestor of `role` (would create a cycle).
     */
    $scope.getAvailableChildRoles = function (role) {
        var canonical = rolesById[role.id] || role;
        var linkedIds = {};
        (canonical.childRoles || []).forEach(function (c) { linkedIds[c.id] = true; });

        return Object.keys(rolesById)
            .map(function (id) { return rolesById[id]; })
            .filter(function (candidate) {
                if (candidate.deleted) return false;
                if (candidate.id === canonical.id) return false;
                if (linkedIds[candidate.id]) return false;
                if (_isReachable(candidate.id, canonical.id)) return false; // would create a cycle
                return true;
            })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
    };

    $scope.addChildRoleToRole = function (role, candidateRole) {
        var canonical = rolesById[role.id];
        var candidateCanonical = rolesById[candidateRole.id];
        if (!canonical || canonical.deleted || !candidateCanonical) return;
        if ($scope.isRoleDirectlyLockedForSuperUser(canonical)) return; // immutable
        if (canonical.childRoles.some(function (c) { return c.id === candidateCanonical.id; })) return;
        if (_isReachable(candidateCanonical.id, canonical.id)) return; // defensive re-check

        canonical.childRoles = canonical.childRoles.concat([candidateCanonical]);
        _refreshDisplayIfSearching();
    };

    // ================================================================
    // CREATE ROLE  (new, not-yet-persisted roles)
    // ================================================================

    $scope.openCreateRoleDialog = function () {
        $mdDialog.show({
            controller:          'CreateRoleDialogController',
            templateUrl:         '/home/main-menu/users/tabs/roles-and-permissions/create-role-dialog.html',
            parent:              angular.element(document.body),
            clickOutsideToClose: false,
            escapeToClose:       true,
            multiple : true,
            locals: {
                allPermissions: $scope.allPermissions,
                allRoles:       Object.keys(rolesById)
                    .map(function (id) { return rolesById[id]; })
                    .filter(function (r) { return !r.deleted; })
                    .sort(function (a, b) { return a.name.localeCompare(b.name); })
            }
        })
            .then(function (result) {
                if (!result) return;
                $scope.pendingNewRoles.push({
                    _tempId:     'temp-' + (++_tempIdCounter),
                    name:        result.name,
                    description: result.description,
                    permissions: result.permissions || [],
                    childRoles:  result.childRoles || []
                });
            })
            .catch(function () {});
    };

    $scope.discardPendingRole = function (pendingRole) {
        $scope.pendingNewRoles = $scope.pendingNewRoles.filter(function (r) {
            return r._tempId !== pendingRole._tempId;
        });
    };

    $scope.getAvailablePermissionsForPendingRole = function (pendingRole) {
        var assignedIds = {};
        (pendingRole.permissions || []).forEach(function (p) { assignedIds[p.id] = true; });
        return ($scope.allPermissions || []).filter(function (p) { return !assignedIds[p.id]; });
    };

    $scope.addPermissionToPendingRole = function (pendingRole, permission) {
        if (pendingRole.permissions.some(function (p) { return p.id === permission.id; })) return;
        pendingRole.permissions.push(permission);
    };

    $scope.removePermissionFromPendingRole = function (pendingRole, permission, $event) {
        if ($event) $event.stopPropagation();
        pendingRole.permissions = pendingRole.permissions.filter(function (p) { return p.id !== permission.id; });
    };

    /**
     * Existing, persisted roles that can be linked as a child of a
     * pending (not-yet-created) role. Same eligibility rules as
     * getAvailableChildRoles, minus the cycle check (a role that
     * doesn't exist yet can't be anyone's ancestor).
     */
    $scope.getAvailableChildRolesForPendingRole = function (pendingRole) {
        var linkedIds = {};
        (pendingRole.childRoles || []).forEach(function (c) { linkedIds[c.id] = true; });

        return Object.keys(rolesById)
            .map(function (id) { return rolesById[id]; })
            .filter(function (candidate) {
                if (candidate.deleted) return false;
                if (linkedIds[candidate.id]) return false;
                return true;
            })
            .sort(function (a, b) { return a.name.localeCompare(b.name); });
    };

    $scope.addChildRoleToPendingRole = function (pendingRole, candidateRole) {
        if (pendingRole.childRoles.some(function (c) { return c.id === candidateRole.id; })) return;
        pendingRole.childRoles.push(candidateRole);
    };

    $scope.removeChildRoleFromPendingRole = function (pendingRole, childRole, $event) {
        if ($event) $event.stopPropagation();
        pendingRole.childRoles = pendingRole.childRoles.filter(function (c) { return c.id !== childRole.id; });
    };

    // ================================================================
    // INLINE NAME/DESCRIPTION EDITING (existing, persisted roles only —
    // root-level, same "nested roles are read-only" rule the Add
    // Permission/Add Child Role controls already follow). Edits land
    // straight on the canonical role object (name/description are plain
    // ng-model bindings once in edit mode), diffed against
    // originalName/originalDescription at Save time like everything else
    // here — no per-field save/cancel, it's all-or-nothing with the rest
    // of the tab's pending changes.
    // ================================================================

    var _editingFields = {}; // "roleId::field" -> true, field is 'name'|'description'

    function _editKey(roleId, field) { return roleId + '::' + field; }

    // While a search filter is active, displayHierarchy is built from
    // CLONED role objects (_pruneRole's angular.extend({}, role, ...) —
    // see SEARCH above), not the canonical ones in rolesById. The inline
    // edit inputs bind ng-model through this function (e.g.
    // ng-model="canonicalRole(role).name") specifically so a keystroke
    // always lands on the canonical object — never on an ephemeral search
    // clone that Save/dirty-checking would never see.
    $scope.canonicalRole = function (role) {
        return rolesById[role.id] || role;
    };

    $scope.isEditingField = function (role, field) {
        return !!_editingFields[_editKey(role.id, field)];
    };

    $scope.startEditingField = function (role, field, $event) {
        if ($event) $event.stopPropagation();
        var canonical = rolesById[role.id];
        if (!canonical || canonical.deleted) return;
        if ($scope.isRoleDirectlyLockedForSuperUser(canonical)) return; // immutable
        _editingFields[_editKey(role.id, field)] = true;
    };

    $scope.stopEditingField = function (role, field, $event) {
        if ($event) $event.stopPropagation();
        delete _editingFields[_editKey(role.id, field)];

        var canonical = rolesById[role.id];
        if (!canonical) return;

        // Name can't be blanked out — revert rather than leave the role
        // with an empty name. Description has no such constraint (an
        // empty one just means "no description").
        if (field === 'name' && !(canonical.name || '').trim()) {
            canonical.name = canonical.originalName;
        }

        _refreshDisplayIfSearching();
    };

    // Commits the field on Enter (name only — description is multi-line,
    // where Enter should insert a newline instead).
    $scope.onEditFieldKeydown = function (role, field, $event) {
        if (field === 'name' && $event.key === 'Enter') {
            $scope.stopEditingField(role, field, $event);
        }
    };

    // ================================================================
    // DIRTY STATE
    // ================================================================

    function _hasIdListDiff(currentIds, originalIds) {
        var current  = currentIds.slice().sort();
        var original = (originalIds || []).slice().sort();
        if (current.length !== original.length) return true;
        for (var i = 0; i < current.length; i++) {
            if (current[i] !== original[i]) return true;
        }
        return false;
    }

    function _hasPermissionDiff(canonical) {
        return _hasIdListDiff(
            canonical.permissions.map(function (p) { return p.id; }),
            canonical.originalPermissionIds
        );
    }

    function _hasChildRoleAddDiff(canonical) {
        // Only checks for ADDITIONS — removals are tracked separately via
        // pendingUnlinks (see CHILD ROLE UNLINK above) and never shrink
        // canonical.childRoles directly, so a length/order difference
        // here can only mean something was added.
        var current  = canonical.childRoles.map(function (c) { return c.id; });
        var original = canonical.originalChildRoleIds || [];
        return current.some(function (id) { return original.indexOf(id) === -1; });
    }

    function _hasNameDiff(canonical) {
        return canonical.name !== canonical.originalName;
    }

    function _hasDescriptionDiff(canonical) {
        return (canonical.description || '') !== (canonical.originalDescription || '');
    }

    $scope.isDirty = function () {
        if ($scope.pendingNewRoles.length > 0) return true;
        if (_hasPendingUnlinks()) return true;
        return Object.keys(rolesById).some(function (id) {
            var r = rolesById[id];
            return r.deleted || _hasPermissionDiff(r) || _hasChildRoleAddDiff(r) ||
                _hasNameDiff(r) || _hasDescriptionDiff(r);
        });
    };

    // Exposed on $rootScope — not $scope.$parent — for two independent
    // reasons: (1) md-tabs interposes its own compiled scope between this
    // controller and UsersRolesDialogController, so a $scope.$parent.foo =
    // write wouldn't land where expected; and (2) $mdDialog always gives
    // its controller an ISOLATE scope, so UsersRolesDialogController's
    // $scope doesn't prototypally inherit from anything anyway — it must
    // read $rootScope directly too (see its own closeDialog comment).
    // $rootScope is the one place both ends can reliably agree on.
    // UsersRolesDialogController's Close button / toolbar X call this (if
    // present) before hiding the dialog, so unsaved Roles & Permissions
    // edits aren't silently lost.
    $rootScope.confirmDiscardRolesChangesIfDirty = function () {
        if (!$scope.isDirty()) return $q.resolve(true);

        return dialogService.showDecisionDialog(
            'Unsaved Changes',
            '<p style="margin:0 0 10px 0;">You have unsaved changes to roles and permissions.</p>' +
            '<p style="margin:0;">If you leave now, they will be <strong>permanently discarded</strong>. ' +
            'Are you sure you want to proceed?</p>'
        ).then(function (decision) {
            return decision === 'proceed';
        });
    };

    $scope.$on('$destroy', function () {
        if ($rootScope.confirmDiscardRolesChangesIfDirty) {
            delete $rootScope.confirmDiscardRolesChangesIfDirty;
        }
    });

    $scope.getUnsavedChangesCount = function () {
        var count = $scope.pendingNewRoles.length + _countPendingUnlinks();
        Object.keys(rolesById).forEach(function (id) {
            var r = rolesById[id];
            if (r.deleted) { count++; return; }

            var currentPerms  = r.permissions.map(function (p) { return p.id; });
            var originalPerms = r.originalPermissionIds || [];
            var permsToAdd    = currentPerms.filter(function (pid) { return originalPerms.indexOf(pid) === -1; });
            var permsToRemove = originalPerms.filter(function (pid) { return currentPerms.indexOf(pid) === -1; });
            count += permsToAdd.length + permsToRemove.length;

            var currentChildren  = r.childRoles.map(function (c) { return c.id; });
            var originalChildren = r.originalChildRoleIds || [];
            var childrenToAdd    = currentChildren.filter(function (cid) { return originalChildren.indexOf(cid) === -1; });
            count += childrenToAdd.length;

            if (_hasNameDiff(r)) count++;
            if (_hasDescriptionDiff(r)) count++;
        });
        return count;
    };

    // ================================================================
    // SAVE CHANGES
    // ================================================================

    $scope.saveChanges = function () {
        if (!$scope.isDirty() || $scope.saving) return;
        $scope.saving = true;

        var ops = [];

        // Reverse index: which parents currently reference each role as a
        // child. Used below so that deleting a role at root level also
        // unlinks it from any parent still pointing to it — otherwise the
        // DELETE could fail server-side on the child_roles FK.
        var parentsOfRoleId = {};
        Object.keys(rolesById).forEach(function (pid) {
            (rolesById[pid].childRoles || []).forEach(function (child) {
                if (!parentsOfRoleId[child.id]) parentsOfRoleId[child.id] = [];
                parentsOfRoleId[child.id].push(pid);
            });
        });

        // 1) Deletes — pre-existing roles marked for full deletion (root-level "Delete")
        Object.keys(rolesById).forEach(function (id) {
            var r = rolesById[id];
            if (!r.deleted) return;

            ops.push({
                description: 'Delete role "' + r.name + '"',
                promise:     RolesService.deleteRole($scope.accountId, id)
            });

            // Defensive: unlink from any parent still referencing this role,
            // so the delete above doesn't fail on the child_roles FK.
            (parentsOfRoleId[id] || []).forEach(function (parentId) {
                var parent = rolesById[parentId];
                if (parent && !parent.deleted) {
                    ops.push({
                        description: 'Unlink "' + r.name + '" from "' + parent.name + '"',
                        promise:     RolesService.removeChildRoles($scope.accountId, parentId, [id])
                    });
                }
            });
        });

        // 2) Explicit unlinks — nested "Delete" clicks (parent↔child edge only)
        Object.keys(pendingUnlinks).forEach(function (parentId) {
            var parent = rolesById[parentId];
            if (!parent || parent.deleted) return; // covered by the defensive unlink above

            var childIds = Object.keys(pendingUnlinks[parentId]);
            if (childIds.length === 0) return;

            ops.push({
                description: 'Unlink ' + childIds.length + ' role(s) from "' + parent.name + '"',
                promise:     RolesService.removeChildRoles($scope.accountId, parentId, childIds)
            });
        });

        // 3) Permission add/remove diffs (skip roles queued for deletion)
        Object.keys(rolesById).forEach(function (id) {
            var r = rolesById[id];
            if (r.deleted) return;

            var current  = r.permissions.map(function (p) { return p.id; });
            var original = r.originalPermissionIds || [];
            var toAdd    = current.filter(function (pid) { return original.indexOf(pid) === -1; });
            var toRemove = original.filter(function (pid) { return current.indexOf(pid) === -1; });

            if (toAdd.length) {
                ops.push({
                    description: 'Add ' + toAdd.length + ' permission(s) to "' + r.name + '"',
                    promise:     RolesService.addPermissionsToRole($scope.accountId, id, toAdd)
                });
            }
            if (toRemove.length) {
                ops.push({
                    description: 'Remove ' + toRemove.length + ' permission(s) from "' + r.name + '"',
                    promise:     RolesService.removePermissionsFromRole($scope.accountId, id, toRemove)
                });
            }
        });

        // 3b) Name/description edits (skip roles queued for deletion — no
        //     point renaming something that's about to be removed)
        Object.keys(rolesById).forEach(function (id) {
            var r = rolesById[id];
            if (r.deleted) return;

            var nameChanged = _hasNameDiff(r);
            var descChanged = _hasDescriptionDiff(r);
            if (!nameChanged && !descChanged) return;

            ops.push({
                description: 'Update "' + r.originalName + '" details',
                promise:     RolesService.updateRole($scope.accountId, id, {
                    name:        r.name,
                    description: r.description
                })
            });
        });

        // 4) Child-role add diffs (skip roles queued for deletion — removals are
        //    handled entirely by steps 1/2 above, this only ever adds)
        Object.keys(rolesById).forEach(function (id) {
            var r = rolesById[id];
            if (r.deleted) return;

            var currentChildren  = r.childRoles.map(function (c) { return c.id; });
            var originalChildren = r.originalChildRoleIds || [];
            var toAddChildren     = currentChildren.filter(function (cid) { return originalChildren.indexOf(cid) === -1; });

            if (toAddChildren.length) {
                ops.push({
                    description: 'Add ' + toAddChildren.length + ' child role(s) to "' + r.name + '"',
                    promise:     RolesService.addChildRoles($scope.accountId, id, toAddChildren)
                });
            }
        });

        // 5) Creates — brand-new roles. If the user also picked child roles
        //    in the create dialog, those can't be sent until the new role
        //    has a real ID, so we chain a follow-up addChildRoles call once
        //    the create call resolves.
        $scope.pendingNewRoles.forEach(function (nr) {
            var childRoleIds = (nr.childRoles || []).map(function (c) { return c.id; });

            var createPromise = RolesService.createRole($scope.accountId, {
                name:           nr.name,
                description:    nr.description,
                authorizations: nr.permissions.map(function (p) { return p.id; })
            });

            if (childRoleIds.length) {
                createPromise = createPromise.then(function (response) {
                    var newRoleId = response.data && response.data.id;
                    if (!newRoleId) return response;
                    return RolesService.addChildRoles($scope.accountId, newRoleId, childRoleIds)
                        .then(function () { return response; });
                });
            }

            ops.push({
                description: 'Create role "' + nr.name + '"' +
                    (childRoleIds.length ? ' with ' + childRoleIds.length + ' child role(s)' : ''),
                promise: createPromise
            });
        });

        if (ops.length === 0) {
            $scope.saving = false;
            return;
        }

        var settled = ops.map(function (op) {
            return op.promise.then(
                function ()      { return { ok: true,  description: op.description }; },
                function (error) { return { ok: false, description: op.description, error: error }; }
            );
        });

        $q.all(settled)
            .then(function (results) {
                var failures = results.filter(function (r) { return !r.ok; });

                if (failures.length === 0) {
                    $mdToast.showSimple('✅ Changes saved successfully');
                } else {
                    var msg = failures.map(function (f) {
                        var detail = (f.error && f.error.data && f.error.data.message) || 'Unknown error';
                        return '• ' + f.description + ': ' + detail;
                    }).join('\n');

                    dialogService.showErrorDialog(
                        'Some changes could not be saved',
                        failures.length + ' of ' + ops.length + ' operation(s) failed:\n' + msg
                    );
                }

                // Reload from server to resync with whatever actually persisted
                loadRolesHierarchy();
            })
            .finally(function () {
                $scope.saving = false;
            });
    };
});

// ================================================================
// rtBodyPortal — moves an element straight to <body> so it lives outside
// the User Management dialog / tabs DOM subtree entirely. Necessary
// because Angular Material applies a CSS transform/perspective to its
// dialog and tab-content wrappers for their own open/slide animations,
// and any such ancestor becomes the containing block for
// `position: fixed` descendants instead of the viewport — which is what
// made the fixed-positioned Add Permission/Add Child Role dropdown render
// increasingly offset the further down the scrollable tree its trigger
// was, and is the same reason Angular Material's own md-tooltip rendered
// garbled/clipped here too (its internal positioning hits the exact same
// issue). Body is a true top-level element with no transform, so
// `position: fixed` there is always viewport-relative. Used for both the
// shared dropdown and the shared nested-role tooltip below.
//
// This element is NOT wrapped in ng-if/ng-include at the point this
// directive links, so there's no competing $animate.enter() trying to
// re-insert it back into its original spot afterward — the move happens
// once, synchronously, before the surrounding template fragment (if any)
// gets inserted into the live DOM.
angular.module('bizmetryApp').directive('rtBodyPortal', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            document.body.appendChild(element[0]);
            scope.$on('$destroy', function () {
                if (element[0].parentNode) {
                    element[0].parentNode.removeChild(element[0]);
                }
            });
        }
    };
});

// rtAutofocus — focuses (and selects the text of) an input/textarea the
// moment it's linked. Used by the inline name/description editors: since
// the field is behind ng-if (swapped in only while isEditingField() is
// true), a plain HTML `autofocus` attribute wouldn't fire — the element
// doesn't exist in the DOM until Angular compiles this ng-if branch, well
// after the page's initial load. $timeout (not a raw setTimeout) so the
// focus happens after Angular's own DOM insertion for this digest settles.
angular.module('bizmetryApp').directive('rtAutofocus', ['$timeout', function ($timeout) {
    return {
        restrict: 'A',
        link: function (scope, element) {
            $timeout(function () {
                element[0].focus();
                if (typeof element[0].select === 'function') {
                    element[0].select();
                }
            });
        }
    };
}]);
